import * as React from 'react';
export const asnSvg = React.forwardRef(function asnSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F0533D',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        fillRule: 'nonzero',
        d: 'M10.28 15.93c.28-.55.46-1.14.51-1.75 0-1.45-1.26-2.73-2.73-3.02-1.46-.3-2.91.5-3.5 1.84a6.92 6.92 0 0 1 2.26-6.98 7.01 7.01 0 0 1 7.27-1.09 6.72 6.72 0 0 1 3.98 6.04 7.2 7.2 0 0 1-1.33 4.3c-1.1 1.7-2.38 3.3-2.38 5.43 0 3 2.1 5.67 4.97 6.59a7.5 7.5 0 0 1-7.4-1.84 7.97 7.97 0 0 1-1.66-9.52h.01zm12.27.07c.46 0 .75-.26.75-.73 0-.45-.29-.72-.75-.72-.47 0-.75.27-.75.72 0 .47.3.73.75.73zm1.16 6.14c-.06-1.17 1.2-2.3 2.27-2.78v-.03c-2.63.35-4.3 1.05-5 2.1a4.58 4.58 0 0 0 0 5.16 7.64 7.64 0 0 0 3.31-3.06c-.31-.4-.51-.88-.58-1.4zm1.16-10.91a4.1 4.1 0 0 0-.29-3.52c-.13.93-.5 1.8-1.09 2.54l-.03.06c-.26-.14-.53-.27-.8-.39-.2-.1-.38-.21-.57-.33a3.02 3.02 0 0 1-1.45-1.9 4.8 4.8 0 0 0 1.77 5.3 8.09 8.09 0 0 1 2.9 3.74c.42-.58.52-1.24.62-1.95.05-.23.25-.47.25-.71a3.52 3.52 0 0 0-1.3-2.86v.02z',
      }),
    ),
  );
});
asnSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var asn = {
  category: 'brand',
  colorable: false,
  name: 'asn',
  svg: asnSvg,
};
